import React from 'react'
import styled from 'styled-components'

import Container from '../Container'

import breakpoints from '../../../constants/breakpoints'

export interface Props {
  children: any
}

const SlideContainer: React.FC<Props> = ({ children }) => (
  <Container>
    <Content>{children}</Content>
  </Container>
)

const Content = styled.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 128px 0 80px 0;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    padding: 88px 0;
  }
`

export default SlideContainer
